// components/admin/AdminSidebar.tsx
import React from 'react';
import {
  LayoutDashboard,
  Users,
  Package,
  Settings,
  Store,
  Tags
} from 'lucide-react';

import Sidebar, { SidebarConfig } from '../../shared/DashboardSidebar';


interface AdminSidebarProps {
  isCollapsed: boolean;
  onToggle: () => void;
  username: string;
  logoUrl?: string;
  isMobile?: boolean;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({
  isCollapsed,
  onToggle,
  username,
  logoUrl,
  isMobile = false
}) => {

  const config: SidebarConfig = {
    username,
    logoUrl,
    onActivateModules: () => {
      window.location.href = '/admin/parametres';
    },
    sections: [
      {
        title: 'Général',
        items: [
          { icon: LayoutDashboard, label: 'Tableau de bord', path: '/admin/overview' },
       
          {
            icon: Users,
            label: 'Utilisateurs',
            path: '/admin/users',
          },
          { icon: Settings, label: 'Paramètres', path: '/admin/settings' }
        ]
      },
      {
        title: 'Modules entreprise',
        items: [
          {
            icon: Store,
            label: 'Les boutiques',
            path: '/admin/shops',
          },
       
          {
            icon: Package,
            label: 'Les secteurs',
            path: '/admin/sectors'
          },

           {
            icon: Tags,
            label: 'Les catégories',
            path: '/admin/categories'
          },
          {
            icon: Package,
            label: 'Produits',
            path: '/admin/products'
          },

        

        ]
      }
    ]
  };

  return (
    <Sidebar
      config={config}
      isCollapsed={isCollapsed}
      onToggle={onToggle}
      isMobile={isMobile}
    />
  );
};

export default AdminSidebar;